import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { fToNow } from '@aibees/shared/utils';

export function aiAnalysisLatestUpdateDate(data?: PeopleTableInfo) {
  return fToNow(
    data?.revelation?.analysis?.content?.created ??
      data?.revelation?.analysis?.created
  );
}

export function doesAiAnalysisHasAnyUpdates(data?: PeopleTableInfo) {
  return !!data?.changes?.ANALYSIS?.length;
}

export function isAiAnalysisUnlocked(data?: PeopleTableInfo) {
  return !!data?.revelation?.analysis?.content;
}
